<template>

  <div>
    
    <ul class="list-group" v-if="placements.length">
      <li class="list-group-item" v-for="(item, index) in placements">
        <a href="javascript:void(0)" @click="showCandidateModal(item.candidate._id, item._id)">Cras justo odio</a>
      </li>
    </ul>

  </div>

</template>

<script>
export default {
  name: 'JobRecommended',
  components: {
  },
  data () {
    return {
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.placements = [
        {
          '_id': '1',
          'name': 'Roberto Marinho',
          'created_at': '2018-02-02 00:00:00',
          'updated_at': '2018-02-02 00:00:00'
        },
        {
          '_id': '2',
          'name': 'Roberto Marinho',
          'created_at': '2018-02-02 00:00:00',
          'updated_at': '2018-02-02 00:00:00'
        },
        {
          '_id': '3',
          'name': 'Roberto Marinho',
          'created_at': '2018-02-02 00:00:00',
          'updated_at': '2018-02-02 00:00:00'
        }
      ]
    },
    /*
    CandidateView
    */
    showCandidateModal (candidateId, placementId) {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobRecommended/JobRecommended.vue